import { Button } from '@mui/material';
import React from 'react'
import { useNavigate } from 'react-router-dom';
import { useAppContext } from '../../../app/AppContext';

import logo from './logog.png'
import "./style.css"

export default function Home() {
    const navigate = useNavigate();
    const { useSetTitle } = useAppContext();
    useSetTitle("Nelore de Produção")
    return (
        <div className='inicialContant'>
            <img className='logo' src={logo} alt="Logo" />
            <div className='inicialContantActions'>
                <Button onClick={() => navigate("nascimento")}>Lancar Nascimento</Button>
            </div>
        </div>
    )
}
